import { removeImageOverlay } from './Strings'

/**
 * 
 * @param array media 
 * @param string formatName 
 * @returns array
 */
const findImageFormat = (media, formatName) => {
    let arrayMedia = []
    if ( media === undefined || media === null) {
      return []; 
    } else if( media.hasOwnProperty('length') ) {
      arrayMedia = [...media];
    } else {
      arrayMedia.push(media);
    }
    const mediaArray = arrayMedia.map( (mediaFile)=> {
        const file = {}
        if(mediaFile.type === 'Image') {
          const [format] = mediaFile.files[0].formats.filter((img) => {
            if (img.format === formatName) {
              return true
            }
            return false
          })
  
          file.src = removeImageOverlay(format.url);
          file.element = 'img';
        } else {
            return false;
        }
        return file;
  
    }, [] ).filter( m => Boolean(m));

    return mediaArray

}

export default findImageFormat